// Wrappers de storage que nunca tiran.
//
// El guard corre en el arranque, antes que cualquier error boundary. Si
// localStorage esta bloqueado (modo estricto de cookies, iframe sandbox,
// Safari privado viejo) el acceso *tira*, no devuelve null. Un throw acá
// mataria el portal entero por un feature accesorio.

const memory = new Map<string, string>();

function backing(kind: 'local' | 'session'): Storage | null {
  try {
    const s = kind === 'local' ? window.localStorage : window.sessionStorage;
    // Probe real: en algunos browsers el getter existe pero setItem tira.
    const probe = '__vg_probe__';
    s.setItem(probe, '1');
    s.removeItem(probe);
    return s;
  } catch {
    return null;
  }
}

export function readJson<T>(kind: 'local' | 'session', key: string): T | null {
  try {
    const raw = backing(kind)?.getItem(key) ?? memory.get(key) ?? null;
    return raw === null ? null : (JSON.parse(raw) as T);
  } catch {
    return null;
  }
}

export function writeJson(kind: 'local' | 'session', key: string, value: unknown): void {
  const raw = JSON.stringify(value);
  memory.set(key, raw);
  try {
    backing(kind)?.setItem(key, raw);
  } catch {
    // memoria alcanza para la vida de la pestaña
  }
}

export function remove(kind: 'local' | 'session', key: string): void {
  memory.delete(key);
  try {
    backing(kind)?.removeItem(key);
  } catch {
    // idem
  }
}
